import { render, staticRenderFns } from "./menu-nav.vue?vue&type=template&id=ebc3574e&scoped=true&"
import script from "./menu-nav.vue?vue&type=script&lang=js&"
export * from "./menu-nav.vue?vue&type=script&lang=js&"
import style0 from "./menu-nav.vue?vue&type=style&index=0&id=ebc3574e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc3574e",
  null
  
)

export default component.exports